/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeDRadiusUpLeftIcon24Solid = forwardRef('ArrowShapeDRadiusUpLeftIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M11.999 3.448c0-1.202-1.454-1.805-2.305-.954l-8.178 8.18a1.875 1.875 0 0 0 0 2.65l8.178 8.18c.85.85 2.305.248 2.305-.955V17c1.8 0 3.18.008 4.564.454 1.37.441 2.807 1.336 4.608 3.24.604.638 1.777.306 1.814-.673.168-4.415-1.09-7.691-3.219-9.865-2.064-2.108-4.872-3.1-7.767-3.153V3.448Z" })));
});
